// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__4jlEb","cardTitle":"ActiveCustomers_cardTitle__+qsBD","chart":"ActiveCustomers_chart__CoP7L"};